import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Courses from '../pages/courses/page';
import Camps from '../pages/camps/page';
import CampSchedule from '../pages/camp-schedule/page';
import Teachers from '../pages/teachers/page';
import Results from '../pages/results/page';
import Trial from '../pages/trial/page';
import Admin from '../pages/admin/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/courses',
    element: <Courses />,
  },
  {
    path: '/camps',
    element: <Camps />,
  },
  {
    path: '/camp-schedule',
    element: <CampSchedule />,
  },
  {
    path: '/teachers',
    element: <Teachers />,
  },
  {
    path: '/results',
    element: <Results />,
  },
  {
    path: '/trial',
    element: <Trial />,
  },
  {
    path: '/admin',
    element: <Admin />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;